import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { AuthorizedRequestArg } from '../signin/auth';
import { refreshToken } from '../signin/authSlice';
import { Goal } from './types';

interface GoalsState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  list: Array<Goal>;
};

export const listGoals = createAsyncThunk('goals/listGoals', async (arg: AuthorizedRequestArg, { dispatch }) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_ROOT}/Goals`,
      {
        credentials: 'include',
        method: "POST",
        headers: new Headers({
          Accept: "application/json",
          Authorization: `Bearer ${arg.authToken}`,
        }),
        body: JSON.stringify({
          'listGoals': {
          }
        }),
      })
      .then(res => res.json());
    return response.data.goals;
  } catch (err) {
    console.log('Error', err);
    dispatch(refreshToken());
  }
});

export const goalsSlice = createSlice({
  name: 'goals',
  initialState: {
    list: [],
    entries: {},
    status: 'idle',
    error: null,
    editingGoalID: null,
  } as GoalsState,
  reducers: {
  },
  extraReducers: builder => {
    builder.addCase(listGoals.pending, (state, action) => {
      state.status = 'loading';
      state.error = null;
    });
    builder.addCase(listGoals.fulfilled, (state, action) => {
      state.status = 'succeeded';
      state.error = null;
      state.list = action.payload || [];
    });
    builder.addCase(listGoals.rejected, (state, action) => {
      state.status = 'failed';
      console.log('Error', action.error.message)
      state.error = action.error.message || null;
    });
  }
});

export const selectAllGoals = (state: RootState) =>
  state.goals.list;

export const selectGoalsForDate = (state: RootState, date: number) =>
  state.goals.list.filter(goal =>
    (goal.startDate || 0) <= date && (goal.endDate || 0) >= date
  );

export default goalsSlice.reducer